import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

export const Tag = iotsUtils.fromList(constants.folder.tag.ids);
